export default __webpack_public_path__ + "static/media/sazeni_barva-min.7e0a9142.png";